export default UX.resizeImages = function (container) {
    let images = [];

    if (typeof container === 'string') {
        images = document.querySelectorAll(`${container} img:not([data-resized]`);
    } else {
        images = container.querySelectorAll('img:not([data-resized])');
    }

    images.forEach(image => {
        if (image?.classlist?.contains('full-width-image')) {
            image?.setAttribute('loading', 'eager');
        }
        image?.setAttribute('data-resized', 'yes');
    });
};
